@if (isActive()) {
    @let actualIconType = iconType();
    @if (actualIconType === EconTypes.SeSvg) {
        <mat-icon
            class="bool-icon-renderer"
            [svgIcon]="icon()"
            matTooltipShowDelay="500"
            [matTooltip]="tooltip() | translate"
        ></mat-icon>
    } @else if (actualIconType === EconTypes.AngularMaterial) {
        <mat-icon
            class="bool-icon-renderer"
            matTooltipShowDelay="500"
            [matTooltip]="tooltip() | translate"
            [ngClass]="{'green': isGreen(),'yellow': isYellow()}"
            >{{ icon() }}</mat-icon>
    } @else if (actualIconType === EconTypes.SeFont) {
        <mat-icon
            fontSet="estensa-icons"
            class="bool-icon-renderer"
            matTooltipShowDelay="500"
            [matTooltip]="tooltip() | translate"
            [ngClass]="{'green': isGreen(),'yellow': isYellow()}"
            >{{ icon() }}</mat-icon
        >
    }
}
